<!--ExperienceVideos: 用户体验中心-视频播放组件 2020/08/26 16:44:24 Sunanguang-->

<template>
  <el-carousel class="its-tabItem" :autoplay="false"  arrow="never" :height="height" @change="carouselChange" trigger="click">
      <el-carousel-item class="its-banner" v-for="(video, i) in tabItem.videos" :key="'video-'+i" indicator-position="outside">
        <div class="its-video-outer" :style="{width:videoStyle.width,height:videoStyle.height}">
          <play-view ref="playViewRef" :item="video" :videoStyle="video" @preview-event="previewEvent"  @fullScreen="fullScreenEvent"></play-view>
        </div>
      </el-carousel-item>
    </el-carousel>
</template>
<script>
import PlayView from '../../../components/PlayView'
export default {
  name:'TeachingBanner',
  components: {
    PlayView
  },
  props:{
    tabItem:{//banner列表
      type: Object,
      default:function(){
        return {
          mediaType: 'video'
        }
      }
    },
    height: {
      type: String,
      default: '300px'
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      videoStyle: {
        width: '0px',
        height: '0px'
      }
    }
  },
  watch: {
    height: {
      handler: function () {
        this.videoStyle.height = parseInt(this.height) + 'px'
        this.videoStyle.width = parseInt(parseInt(this.videoStyle.height)*4/3) + 'px'
        console.log('style', this.videoStyle)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    previewEvent: function (data) {
      this.$emit('preview-event', data)
    },
    carouselChange: function(data){
      this.stopVideo()
      if(this.fatherAction){
        this.fatherAction({type: 'change', index: data})
      }
    },
    fullScreenEvent: function (isFullScreen) {
      console.log(isFullScreen)
      this.$emit('fullScreen', isFullScreen)
    },
    stopVideo: function () {
      // 切换视频，停止所有视频的播放
      let videos = this.$refs.playViewRef
      if(videos.length>0){
        videos.forEach((video)=>{
          video.stopPlayer()
        })
      }
    }
  }
}
</script>
<style scoped>
.its-tabItem{
  z-index: 1;
  width: 775px;
  margin: 0 auto;
}
.its-tabItem >>> .el-carousel__indicators{
  display: block !important;
}
.its-tabItem >>> .el-carousel__indicator--horizontal{
  padding: 12px 8px;
}
.its-tabItem >>> .el-carousel__button{
  background-color: #EAEAEA;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  opacity: 1;
}
.its-tabItem >>> .is-active .el-carousel__button{
  background-color: #9A9A9A;
}
.its-video-outer {
  margin: 0 auto;
}
</style>
